module.exports = __webpack_public_path__ + "static/img/sonartes.e60020d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proyectos/sonartes.png
// module id = lkiE
// module chunks = 0